// 封装导出Excel方法
function excel(header, data, textName) {
    if (header !== undefined || data !== undefined) {
        if (header.length > 0 && data.length > 0) {
            // 表头
            var table = '<table border="1px" cellspacing="0" cellpadding="0">';
            table += '<thead>';
            for (let i = 0; i < header.length; i++) {
                table += '<th>' + header[i].value + '</th>';
            }
            table += '</thead>';
            table += '<tbody>'
            // 数据内容
            var _body = "";
            for (let j = 0; j < data.length; j++) {
                _body += '<tr>';
                for (let i = 0; i < header.length; i++) {
                    _body += '<td>';
                    _body += `${data[j][header[i].keys]}`;
                    _body += '</td>';
                }
                _body += '</tr>';
            }
            table += _body;
            table += '</tbody>';
            table += '</table>';
            // 导出
            var html =
                "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
            html += '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
            html += '<meta http-equiv="content-type" content="application/vnd.ms-excel';
            html += '; charset=UTF-8">';
            html += "<head>";
            html += "</head>";
            html += "<body>";
            html += table;
            html += "</body>";
            html += "</html>";
            var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(html);
            var link = document.createElement("a");
            link.href = uri;
            link.style = "visibility:hidden";
            // link.download = `${"excel.xlsx"}`;
            link.download = `${textName}` + ".xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
/**
 * 导出excel
 * @param {Object} title  标题列key-val
 * @param {Object} data   值列key-val
 * @param {Object} fileName  文件名称
 */
function fn(name, title, data, fileName) {
    var CSV = '';
    var row = "";

    CSV += '采集点' + name + '\r\n';

    for (var i = 0; i < title.length; i++) {
        if (title[i].value) {
            row += title[i].value + ',';
        }
    }
    row = row.slice(0, -1);
    CSV += row + '\r\n';

    for (var i = 0; i < data.length; i++) {
        var row = "";
        for (var j = 0; j < title.length; j++) {
            if (title[j].value) {
                row += '"' + (data[i][title[j].keys] ? data[i][title[j].keys] : "") + '"\t,';
            }
        }
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
    }

    if (CSV == '') {
        alert("Invalid data");
        return;
    }

    var fileName = fileName;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        console.log('---')
        var str = "------";
        let uri = 'data:text/csv;charset=utf-8,' + str;
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download = "export.csv";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    } else {
        let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURI(CSV);
        var link = document.createElement("a");
        link.href = uri;

        link.style.visibility = "hidden";
        link.download = fileName + ".csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

// 导出excel
function JSONToExcelConvertor(name, title, datas, fileName) {
    let arr = [];
    for (let i = 0; i < title.length; i++) {
        arr.push(title[i].value);
    }
    let list = [];
    for (let i = 0; i < datas.length; i++) {
        (function (i) {
            for (let j = 0; j < title.length; j++) {
                list.push(datas[i][title[j].keys])
            }
        }(i))
    }
    let index = list.length / arr.length;
    var data = [arr];
    for (let i = 0; i < index; i++) {
        data.push(list.slice(i * arr.length, i * arr.length + arr.length));
    }
    var csvContent = "data:text/csv;charset=utf-8,\ufeff";
    if (window.navigator.msSaveOrOpenBlob) {
        csvContent = "\ufeff";
    }
    csvContent += '采集点：' + name + "\n";
    data.forEach(function (infoArray, index) {
        let dataString = infoArray.join(",");
        csvContent += index < data.length ? dataString + "\n" : dataString;
    });
    if (window.navigator.msSaveOrOpenBlob) {
        // if browser is IE
        var blob = new Blob([decodeURIComponent(encodeURI(csvContent))], {
            type: "text/csv;charset=utf-8;"
        });
        navigator.msSaveBlob(blob, fileName + '.csv');
    } else {
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName + ".csv");
        document.body.appendChild(link);
        link.click();
    }
}

export {
    excel,
    JSONToExcelConvertor
}